import { helmetAccessoryItem, jacketAccessoryItem } from './accessoryItem';

import { janusVehicle1, janusVehicle2 } from './vehicleItem';

const oemId = 'D6DiJsSPStvahAOLApcF';
const checkoutItems = [
	janusVehicle1,
	janusVehicle2,
	helmetAccessoryItem,
	helmetAccessoryItem,
	jacketAccessoryItem,
];
// eslint-disable-next-line no-restricted-syntax
for (const item of checkoutItems) {
	item.oemId = oemId;
}

const janusDummyData = {
	checkoutItems,
	prevPage: '/',
	oemLogo: 'https://cdn-0.motorcycle-logos.com/wp-content/uploads/2017/01/Janus-Logo.png',
};

export default janusDummyData;
